import React, { PureComponent } from 'react'
import { Checkbox, Paper, ListItem, Grid, Select, MenuItem } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess } from '../../utils/api'

// local components
import EditActionComponent from '../common/EditActionComponent'

class TvDisplay extends PureComponent {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { list, data, editMode } = this.props

    const TvList = list.filter((item) => item.pluginType === 'TV')
    const selectedTvPlugin = list.find((item) => item.id === data.pluginId) || {}

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {hasAccess() ? (
            <div className="pull-right margin-bottom-small">
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            </div>
          ) : (
            <div className="pull-right margin-bottom-small"></div>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="paper-page">
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  TV Products
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin set-width">
                  {editMode ? (
                    <Select value={data.pluginId} onChange={this.onChange('pluginId')}>
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {TvList.map((item, index) => {
                        return (
                          <MenuItem key={index} value={item.id}>
                            {item.productSKU}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  ) : (
                    <span>{selectedTvPlugin.productSKU}</span>
                  )}
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  TVs Allowed
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {selectedTvPlugin.availableDevices || 0}
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  Enable
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {editMode ? (
                    <Checkbox checked={data.enabled} onChange={this.onChange('enabled', true)} />
                  ) : (
                    <span>{data.enabled ? 'Enabled' : 'Not Enabled'}</span>
                  )}
                </Grid>
              </Grid>
            </ListItem>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default TvDisplay



// WEBPACK FOOTER //
// ./src/components/TvDisplay/index.js